import React from 'react';
import { Accordion, AccordionItem, AccordionTrigger, AccordionContent } from '../Accordion';
const faqs = [{
  q: 'Какой трактор подойдёт для моего хозяйства?',
  a: 'Зависит от площади и задач. Напишите нам — подберём за 5 минут.'
}, {
  q: 'Какие условия лизинга?',
  a: 'Вся техника доступна для оформления в лизинг. Условия зависят от клиента — поможем подобрать оптимальную программу.'
}, {
  q: 'Можно ли купить без первоначального взноса?',
  a: 'Да, при условии согласования с лизинговыми компаниями. Напишите — обсудим условия индивидуально.'
}, {
  q: 'Какая гарантия?',
  a: 'Официальная гарантия — 3 года или 1500 моточасов. Сервис и оригинальные запчасти со склада.'
}, {
  q: 'Доставляете по Казахстану?',
  a: 'Доставляем в Алматы и Алматинскую область. Условия доставки в другие регионы Казахстана обсуждаются лично.'
}];
export function FaqSection() {
  return <section className="bg-[#F5F7FA] px-5 py-14 md:px-12 lg:px-24" data-id="element-47">
      <div className="max-w-2xl mx-auto" data-id="element-48">
        <h2 className="font-heading font-bold text-[28px] md:text-[36px] text-[#0A1A3F] text-center mb-8" data-id="element-49">
          Частые вопросы
        </h2>

        <Accordion type="single" defaultValue="item-0" data-id="element-50">
          {faqs.map((faq, i) => <AccordionItem key={i} value={`item-${i}`} data-id="element-51">
              <AccordionTrigger className="text-left font-heading font-semibold text-[15px] md:text-base text-[#0A1A3F]" data-id="element-52">
                {faq.q}
              </AccordionTrigger>
              <AccordionContent className="text-sm md:text-base text-gray-600 leading-relaxed" data-id="element-53">
                {faq.a}
              </AccordionContent>
            </AccordionItem>)}
        </Accordion>
      </div>
    </section>;
}